
import Vue from "vue";
import { AwsDocument } from "@/models/base/aws-document";
import { ModalService } from "@/services";
import AppAwsFilesInfoModal from "@/components/aws-files-modules/AwsFilesInfoModal.vue";


export default Vue.extend({
	computed: {
		docs():AwsDocument[] | undefined{
			return ModalService.openedAwsDocumentStates[ModalService.openedAwsDocumentStates.length-1];
		}
	},
	methods: {
		closeLast(){
			ModalService.openedAwsDocumentStates.pop();
		}
	},
	components: {
		AppAwsFilesInfoModal
	}
});
